var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81343 7.21284C8.10632 6.91994 8.58119 6.91994 8.87409 7.21284L17.3741 15.7129C17.667 16.0058 17.667 16.4806 17.3741 16.7735C17.0812 17.0664 16.6063 17.0664 16.3134 16.7735L7.81343 8.2735C7.52053 7.9806 7.52053 7.50573 7.81343 7.21284Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8438 6.49316C17.258 6.49316 17.5938 6.82894 17.5938 7.24316V16.2432C17.5938 16.6574 17.258 16.9932 16.8438 16.9932H7.84375C7.42953 16.9932 7.09375 16.6574 7.09375 16.2432C7.09375 15.8289 7.42953 15.4932 7.84375 15.4932H16.0938V7.24316C16.0938 6.82894 16.4295 6.49316 16.8438 6.49316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFooter);
export default __webpack_public_path__ + "static/media/arrow-footer.ad06e7005722145837075a8f610d0c93.svg";
export { ForwardRef as ReactComponent };